angular.module('impactx.util').directive('ixAmountInput', function () {
    return {
        restrict: 'E',
        require: '^form',
        controller: 'AmountInputCtrl',
        controllerAs: 'amountInputCtrl',
        templateUrl: 'shared/input/templates/amountinput.tmpl.html',
        scope: {
            name: "@",
            floatingLabel: "@",
            required: "=",
            amount: "=",
            zeroAllowed: "=",
            hasFloatingLabel: "=?",
            hideLabel: "=?",
            readOnly: "=?",
            clazz: "@"
        },
        link: function (scope, element, attrs, formCtrl) {
            scope.form = formCtrl;
        }
    };
});